export default {
    client: "CLIENT",
    name: "NAAM",
    quote: "OFFERTE",
    invoice: "FACTUUR",
    date: "DATUM",
    download_invoice: "Factuur downloaden",
    send_notification: "Melding verzenden",
    trip_programme: "REISPROGRAMMA",
    pax: "Pax",
    total_program: "Totaal programma",
    total_deposit: "TOTALE STORTING",
    payment_method: "BETALINGSMETHODE",
    bank_transfer: "BANKOVERSCHRIJVING",
    bank_name: "BANKNAAM",
    iban: "IBAN",
    swift_bic: "SWIFT/BIC",
    address: "ADRES",
    concept: "CONCEPT",
    trip_details: {
      case_name: "CASENAAM",
      destination: "BESTEMMING",
      accommodation: "ACCOMMODATIE",
      transfer: "OVERDRACHT",
      ebike: "EBIKE",
      luggage_transfer: "BAGAGE OVERDRACHT",
      date: "DATUM"
    }
  }
  